import React from 'react'
import PropTypes from 'prop-types'
import { SvgIcon } from '@material-ui/core/'
import { mdiPencil } from '@mdi/js'

import TooltipIconButton from '../TooltipIconButton'

class EditIconButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    tooltipTitle: PropTypes.node,
  }

  static defaultProps = {
    tooltipTitle: '',
  }

  render() {
    return (
      <TooltipIconButton
        color="primary"
        onClick={this.props.onClick}
        tooltipTitle={this.props.tooltipTitle}
        variant="contained"
      >
        <SvgIcon>
          <path d={mdiPencil} />
        </SvgIcon>
      </TooltipIconButton>
    )
  }
}

export default EditIconButton
